<script lang="ts" setup>
import BaseCard from "@/components/BaseCard.vue";
import BaseContent from "@/components/BaseContent.vue";
import BasePill from "@/components/BasePill.vue";
import BaseSubContent from "@/components/BaseSubContent.vue";
import TreasureItem from "@/components/TreasureItem.vue";
import {
  useGetAreasFromStages,
  useGetQuestsFromStagesByArea,
} from "@/composables/stage";
import { Link, usePage } from "@inertiajs/vue3";

const page = usePage();
const props = defineProps<{
  character: Character;
}>();

const areas = useGetAreasFromStages(
  props.character.drop_reward_stages.map((s) => s.stage),
);
</script>

<template>
  <BaseCard
    v-if="
      character.drop_reward_stages?.length > 0 ||
      character.treasure_exchanges?.length
    "
    class="!gap-0 divide-y divide-green-900/75 !p-0"
  >
    <template #heading>Acquirement</template>

    <BaseContent v-for="area in areas" class="p-4">
      <img
        v-if="area.type === 'Event'"
        :alt="area.name"
        :src="`${page.props.app.cdn_url}/assets/en/${area.images['button']}`"
        class="w-full"
      />
      <template #header
        ><span
          >{{ area.name }}
          <BasePill
            >{{ area.type
            }}<span v-if="area.chapter"
              >&nbsp;Area {{ area.id }}</span
            ></BasePill
          ></span
        >
      </template>
      <BaseSubContent
        v-for="quest in useGetQuestsFromStagesByArea(
          character.drop_reward_stages.map((s) => s.stage),
          area,
        )"
        :header="`${quest.id % 10}. ${quest.name}`"
      >
        <div class="flex flex-row gap-2">
          <Link
            v-for="stage in character.drop_reward_stages
              .map((s) => s.stage)
              .filter((s) => s.quest.id === quest.id)"
            :href="
              route('stages.show', {
                stage: stage.id,
              })
            "
          >
            {{ stage.difficulty }}
          </Link>
        </div>
      </BaseSubContent>
    </BaseContent>

    <BaseContent v-if="character.treasure_exchanges?.length > 0" class="p-4">
      <template #header>Treasure Exchange</template>

      <div
        v-for="exchange in character.treasure_exchanges"
        class="flex flex-row gap-2"
      >
        <TreasureItem :scale="0.5" :treasureItem="exchange.treasure_item" />

        <BaseSubContent
          :header="exchange.treasure_item.name"
          class="place-self-center"
        >
          x{{ exchange.price }}
        </BaseSubContent>
      </div>
    </BaseContent>
  </BaseCard>
</template>

<style scoped></style>
